/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import {getState} from '../../twd/twd'
import useBenchmarks from './use-benchmarks'
import useTickers from './use-tickers'

getState('corporates.scatter-graph', {
    rating: 'INVESTMENT_GRADE'
})

const colors = [
    '#FFA21F',
    '#FF9C9C',
    '#B7C9ED',
    '#241056',
    '#3991FF',

    '#FF5593',
    '#0065E3',
    '#FFA120',
    '#65ECED',
    '#5627D8',
    '#63AD02'
]

export const Context = React.createContext()
export const ContextProvider = ({children}) => {

    const state = getState('corporates.scatter-graph')
    const [rating, setRating_] = React.useState(state.value.rating || 'INVESTMENT_GRADE')
    const setRating = React.useCallback((m) => {
        state.set({rating:m})
        setRating_(m)
    }, [])

    const benchmarks = useBenchmarks()
    const tickers = useTickers({rating})

    return <Context.Provider value={{
        rating, setRating,
        colors,
        ...benchmarks,
        ...tickers
    }}>{children}</Context.Provider>
}
export default () => React.useContext(Context)

